import { type PropsWithChildren, useRef } from "react";

import clsx from "clsx";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { type TableSelection } from "@devexpress/dx-react-grid-bootstrap4";
import { CustomCheckbox } from "@shared/custom-checkbox";

export const TableSelectionHeaderCell = ({
  someSelected,
  onToggle,
}: PropsWithChildren<TableSelection.HeaderCellProps>) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const checkboxRef = useRef<HTMLInputElement>(null);

  return (
    <th
      className={clsx(
        "left-0 dx-g-bs4-header-cell text-nowrap border-right",
        "dx-g-bs4-fixed-cell position-sticky z-1",
      )}
    >
      <div className="flex items-center justify-center w-full h-full"></div>
      <div className="absolute h-[45%] w-[1px] top-[27.5%] right-0 bg-gray-1" />
    </th>
  );
};
